/* Redesign — legal policy TOC (/policies/*)
   Builds the "On this page" list from the h2s Shopify renders in
   .shopify-policy__body, then highlights the section in view. Everything is
   derived from the served prose — no content is authored here, so a policy
   edited in the admin re-numbers itself. The nav ships hidden and stays
   hidden when a policy has fewer than two h2s (a one-section policy needs no
   contents list).

   Scrollspy is scroll-position math rather than IntersectionObserver — the
   same choice as the article TOC, which documents the reasoning. */
(function () {
  var nav = document.querySelector('[data-rd-legal-toc]');
  var body = document.querySelector('.shopify-policy__body');
  if (!nav || !body) return;

  /* The stores' real policy bodies vary: privacy sections are h3s and terms
     has no headings at all (strong runs inside two giant paragraphs). Key on
     h2s, fall back to h3s — never divine sections from <strong>, that's
     content archaeology. Fewer than two either way → the TOC stays hidden
     and the page is just well-set prose. h3 mode also flags the wrapper so
     the CSS can give the only headings the document has the full section
     treatment (a restyle of frozen headings, which is allowed; re-levelling
     them in the admin would not be). */
  var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
  if (heads.length < 2) {
    heads = Array.prototype.slice.call(body.querySelectorAll('h3'));
    if (heads.length < 2) return;
    var legalRoot = document.querySelector('.rd-legal');
    if (legalRoot) legalRoot.classList.add('rd-legal--h3');
  }

  var wrap = nav.querySelector('[data-rd-legal-links]');
  var links = heads.map(function (h, i) {
    if (!h.id) {
      var slug = (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
      h.id = 'policy-' + (slug || 'section-' + (i + 1));
    }
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = String(i + 1).padStart(2, '0') + ' · ' + (h.textContent || '').trim();
    wrap.appendChild(a);
    return a;
  });
  nav.hidden = false;

  var current = -1;
  function spy() {
    var line = window.innerHeight * 0.3;
    var active = 0;
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].getBoundingClientRect().top <= line) active = i;
    }
    if (active !== current) {
      if (current >= 0) links[current].removeAttribute('aria-current');
      links[active].setAttribute('aria-current', 'true');
      current = active;
    }
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { spy(); ticking = false; });
  }, { passive: true });
  spy();
})();
